import EventEmitter from 'eventemitter3';
import components from '../registry.js';
import Reveal from '../utils/reveal.js';

export default class AppController extends EventEmitter {
	constructor() {
		super();
		this.components = [];
		this.components_map = components;
		this.menu = null;
		this.barba = null;
		this.reveal = null;
		this.ready = this.init();
	}

	async init() {
		document.documentElement.classList.add('js');
		this.initReveal(document);

		const barbaReady = import('../transitions/page.js');
		await this.instantiateComponents(document);

		const { default: initBarba } = await barbaReady;
		this.barba = initBarba(this);
	}

	initReveal(root = document) {
		this.reveal?.destroy();
		this.reveal = new Reveal(root);
	}

	async instantiateComponents(root = document) {
		const nodes = Array.from(root.querySelectorAll('[data-component]')).filter(
			(el) => el.dataset.mtstReady !== '1'
		);

		await Promise.all(
			nodes.map(async (el) => {
				const name = el.getAttribute('data-component');
				const loader = this.components_map[name];
				if (!loader) return;

				el.dataset.mtstReady = '1';

				try {
					const mod = await loader();
					const Ctor = mod.default;
					if (!Ctor) return;

					const instance = new Ctor(el);
					instance.__name = name;
					this.components.push(instance);

					if (name === 'site-menu') {
						this.menu = instance;
					}
				} catch (error) {
					el.dataset.mtstReady = '';
					console.error(`[app] Impossible d’instancier « ${name} »`, error);
				}
			})
		);
	}

	destroyPageComponents() {
		this.components = this.components.filter((component) => {
			if (component.__name === 'site-menu') return true;
			component.destroy?.();
			return false;
		});
	}
}
